var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _vm.viewData.loading
        ? _c("loading-list")
        : _c(
            "b-container",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
                      },
                      [
                        _c("h1", { staticClass: "h2" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewData.id
                                  ? `Editar ${_vm.state.name}`
                                  : "Novo Membro"
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("b-breadcrumb", {
                        attrs: {
                          items: [
                            {
                              text: "Lista de Membros da Cooperativa",
                              href: `#/cooperative-members/${this.state.cooperative}`
                            },
                            {
                              text: "Cadastro de Membro de Cooperativa",
                              href: "#",
                              active: true
                            }
                          ]
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-form",
                            [
                              _c("error-container", {
                                attrs: { errors: _vm.viewData.errors || [] }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Nome" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o nome",
                                      state: _vm.isOk("name")
                                    },
                                    model: {
                                      value: _vm.state.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "name", $$v)
                                      },
                                      expression: "state.name"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("name")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "CPF/CNPJ",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "###.###.###-##",
                                          "##.###.###/####-##"
                                        ],
                                        expression:
                                          "['###.###.###-##', '##.###.###/####-##']"
                                      }
                                    ],
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o CPF/CNPJ",
                                      state: _vm.isOk("socialNumber")
                                    },
                                    model: {
                                      value: _vm.state.socialNumber,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "socialNumber", $$v)
                                      },
                                      expression: "state.socialNumber"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("socialNumber")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Email" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o email",
                                      state: _vm.isOk("email")
                                    },
                                    model: {
                                      value: _vm.state.email,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "email", $$v)
                                      },
                                      expression: "state.email"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("email")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Telefone",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: [
                                          "(##) ####-####",
                                          "(##) #####-####"
                                        ],
                                        expression:
                                          "['(##) ####-####', '(##) #####-####']"
                                      }
                                    ],
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o Telefone",
                                      state: _vm.isOk("phone")
                                    },
                                    model: {
                                      value: _vm.state.phone,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "phone", $$v)
                                      },
                                      expression: "state.phone"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("phone")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-1",
                                    label: "Data Início",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("startDate"),
                                      id: "example-datepicker-beg",
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.startDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "startDate", $$v)
                                      },
                                      expression: "state.startDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("startDate")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("startDate")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    id: "input-group-2",
                                    label: "Data Fim",
                                    "label-for": "input-1"
                                  }
                                },
                                [
                                  _c("b-form-datepicker", {
                                    staticClass: "mb-2",
                                    attrs: {
                                      state: _vm.isOk("endDate"),
                                      id: "example-datepicker-end",
                                      placeholder: "Selecione uma data"
                                    },
                                    model: {
                                      value: _vm.state.endDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "endDate", $$v)
                                      },
                                      expression: "state.endDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("endDate")))
                                  ]),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("endDate")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Estado Civil" } },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.maritialStatus },
                                    model: {
                                      value: _vm.state.maritalStatus,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.state,
                                          "maritalStatus",
                                          $$v
                                        )
                                      },
                                      expression: "state.maritalStatus"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Nacionalidade" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe o Nacionalidade",
                                      state: _vm.isOk("nationality")
                                    },
                                    model: {
                                      value: _vm.state.nationality,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "nationality", $$v)
                                      },
                                      expression: "state.nationality"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("nationality")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-group",
                                { attrs: { label: "Profissão" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      required: "",
                                      placeholder: "Informe a Profissão",
                                      state: _vm.isOk("profession")
                                    },
                                    model: {
                                      value: _vm.state.profession,
                                      callback: function($$v) {
                                        _vm.$set(_vm.state, "profession", $$v)
                                      },
                                      expression: "state.profession"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.getError("profession")))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("submit-button", {
                                attrs: {
                                  action: () => _vm.save(),
                                  label: "Salvar"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }